'use client';

import {FC} from 'react';

import {useWindowSize} from '@zoefin/hooks';

import styles from './styles.module.scss';

const VideoPlayer: FC = () => {
  // `width` is undefined until the client measures the viewport, so the
  // server render and first client render agree (both render nothing below).
  const {width} = useWindowSize();
  const videoSource =
    width === undefined
      ? undefined
      : width <= 768
        ? '/static/img/homepage/video-medium.mp4'
        : '/static/img/homepage/video-high.mp4';

  if (!videoSource) return null;

  return (
    <video
      className={styles['hero__picture_video']}
      autoPlay
      muted
      loop
      playsInline>
      <source src={videoSource} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;
